module.exports = __webpack_public_path__ + "img/DAG peptide.0db41380.png";